import React from 'react'
import { Icon } from '@iconify/react';
// import { FaInstagram } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa6";
import { Link } from 'react-router-dom';

export default function ContactInfoWidget({withIcon, title}) {
  return (
    <>
      {title && <h2 className="cs-widget_title">{title}</h2>}
      <ul className="cs-menu_widget cs-style1 cs-mp0">
        <li className='social-icons'>
          {withIcon?<span className='cs-accent_color'><Icon icon="material-symbols:add-call-rounded" /></span>:''}
          {/* <Link to="https://www.instagram.com/rlabgroup/?hl=en" target="_blank" rel="noopener noreferrer"><FaInstagram className="social-icon"/></Link> */}
          <Link to="https://www.linkedin.com/company/rlab-group" target="_blank" rel="noopener noreferrer"><FaLinkedin className="social-icon" /></Link>
          <Link to="https://www.x.com/GroupRlab?s=09" target="_blank" rel="noopener noreferrer"><FaTwitter className="social-icon" /></Link>
          
        </li>
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:envelope" /></span>:''}
          info@rlabgroup.ca
        </li>
        <li>
          {withIcon?<span className='cs-accent_color'><Icon icon="mdi:map-marker" /></span>:''}
          55 Ontario St. <br />Toronto, Ontario <br />M5A 0T8
        </li>
      </ul>
    </>
  )
}
